import * as Types from "../types";

export const updateInitialLoadFlag = dispatch => {
  return dispatch({ type: Types.UPDATE_INITIAL_LOAD_FLAG });
};
